import {
  GetAllNamedElementsResponse,
  GetNamedElementSettingsResponse,
  SetNamedElementResponse,
} from '@fullstory/proto/fs/services/dx-objects';
import { int64, timestamp } from '@fullstory/proto/google/protobuf';
import { NativePlatform } from '@fullstory/proto/fs/api/segment';
import { Visibility } from '@fullstory/proto/fs/gcloud/dstore/protoauditstore';

export const NAMED_ELEMENTS_RESPONSE: GetAllNamedElementsResponse = {
  namedElements: [
    {
      namedElement: {
        namedElement: {
          id: '123',
          name: 'named element 1',
          apiName: '',
          platformSelectors: [
            { selector: 'selector1', platforms: [NativePlatform.NATIVE_PLATFORM_WEB] },
          ],
          description: 'test description 1',
          suggestion: null,
        },
        metadata: {
          archived: false,
          visibility: Visibility.UNSET,
          lastUpdated: '2023-04-10T18:13:26.136150Z' as timestamp,
          lastUpdatedBy: 'FullStory',
          created: '2023-04-10T18:13:26.136150Z' as timestamp,
          createdBy: 'FullStory',
          version: '1' as int64,
          sequentialVersion: '1' as int64,
        },
        createIdempotenceKey: '123',
      },
    },
    {
      namedElement: {
        namedElement: {
          id: '456',
          name: 'named element 2',
          apiName: '',
          platformSelectors: [
            { selector: 'selector2', platforms: [NativePlatform.NATIVE_PLATFORM_WEB] },
          ],
          description: 'test description 2',
          suggestion: null,
        },
        metadata: {
          archived: false,
          visibility: Visibility.UNSET,
          lastUpdated: '2023-04-10T18:13:26.136150Z' as timestamp,
          lastUpdatedBy: 'FullStory',
          created: '2023-04-10T18:13:26.136150Z' as timestamp,
          createdBy: 'FullStory',
          version: '1' as int64,
          sequentialVersion: '1' as int64,
        },
        createIdempotenceKey: '456',
      },
    },
    {
      namedElement: {
        namedElement: {
          id: 'watchedElement1',
          name: 'watched element 1',
          apiName: '',
          platformSelectors: [
            { selector: 'selector2', platforms: [NativePlatform.NATIVE_PLATFORM_WEB] },
          ],
          description: "Named element that's also a watched element",
          suggestion: null,
        },
        metadata: {
          archived: false,
          visibility: Visibility.UNSET,
          lastUpdated: '2023-04-10T18:13:26.136150Z' as timestamp,
          lastUpdatedBy: 'FullStory',
          created: '2023-04-10T18:13:26.136150Z' as timestamp,
          createdBy: 'FullStory',
          version: '1' as int64,
          sequentialVersion: '1' as int64,
        },
        createIdempotenceKey: 'watchedElement1',
      },
    },
    {
      namedElement: {
        namedElement: {
          id: 'archivedWatchedElement1',
          name: 'Archived Watched Element',
          apiName: '',
          platformSelectors: [
            { selector: 'selector2', platforms: [NativePlatform.NATIVE_PLATFORM_WEB] },
          ],
          description: "Named element that's also a watched element",
          suggestion: null,
        },
        metadata: {
          archived: true,
          visibility: Visibility.UNSET,
          lastUpdated: '2023-04-10T18:13:26.136150Z' as timestamp,
          lastUpdatedBy: 'FullStory',
          created: '2023-04-10T18:13:26.136150Z' as timestamp,
          createdBy: 'FullStory',
          version: '1' as int64,
          sequentialVersion: '1' as int64,
        },
        createIdempotenceKey: 'archivedWatchedElement1',
      },
    },
  ],
  pendingSuggestedElements: [],
  activeLimit: 1000,
};

export const NAMED_ELEMENTS_RESPONSE_MIXED_METADATA: GetAllNamedElementsResponse = {
  namedElements: [
    {
      namedElement: {
        namedElement: {
          id: '123',
          name: 'named element 1',
          apiName: '',
          platformSelectors: [
            { selector: 'selector1', platforms: [NativePlatform.NATIVE_PLATFORM_WEB] },
          ],
          description: 'test description 1',
          suggestion: null,
        },
        metadata: {
          lastUpdated: null,
          lastUpdatedBy: 'me',
          created: null,
          createdBy: 'me',
          archived: false,
          visibility: Visibility.UNSET,
          sequentialVersion: '123' as int64,
          version: '123' as int64,
        },
        createIdempotenceKey: '123',
      },
    },
    {
      namedElement: {
        namedElement: {
          id: '456',
          name: 'named element 2',
          apiName: '',
          platformSelectors: [
            { selector: 'selector2', platforms: [NativePlatform.NATIVE_PLATFORM_WEB] },
          ],
          description: 'test description 2',
          suggestion: null,
        },
        metadata: {
          lastUpdated: null,
          lastUpdatedBy: 'you',
          created: null,
          createdBy: 'you',
          archived: false,
          visibility: Visibility.UNSET,
          sequentialVersion: '456' as int64,
          version: '456' as int64,
        },
        createIdempotenceKey: '456',
      },
    },
    {
      namedElement: {
        namedElement: {
          id: '789',
          name: 'named element 3',
          apiName: '',
          platformSelectors: [
            { selector: 'selector3', platforms: [NativePlatform.NATIVE_PLATFORM_WEB] },
          ],
          description: 'test description 3',
          suggestion: null,
        },
        metadata: {
          lastUpdated: null,
          lastUpdatedBy: 'someone',
          created: null,
          createdBy: 'someone',
          archived: true,
          visibility: Visibility.UNSET,
          sequentialVersion: '789' as int64,
          version: '789' as int64,
        },
        createIdempotenceKey: '789',
      },
    },
  ],
  pendingSuggestedElements: [],
  activeLimit: 1000,
};

export const SET_NAMED_ELEMENTS_RESPONSE: SetNamedElementResponse = {
  namedElement: {
    namedElement: {
      namedElement: {
        id: '123',
        name: 'named element 1',
        apiName: '',
        platformSelectors: [
          { selector: 'selector1', platforms: [NativePlatform.NATIVE_PLATFORM_WEB] },
        ],
        description: 'test description 1',
        suggestion: null,
      },
      metadata: null,
      createIdempotenceKey: '123',
    },
  },
};

export const NAMED_ELEMENTS_RESPONSE_EMPTY: GetAllNamedElementsResponse = {
  namedElements: [],
  pendingSuggestedElements: [],
  activeLimit: 1000,
};

export const NAMED_ELEMENTS_SETTINGS_RESPONSE: GetNamedElementSettingsResponse = {
  namedElements: [],
  pageInfo: null,
  sessionQuota: null,
  activeCount: 0,
  activeLimit: 0,
  activeIssuesCount: 0,
};
